export var AudioDirection;
(function (AudioDirection) {
    AudioDirection[AudioDirection["inactive"] = 0] = "inactive";
    AudioDirection[AudioDirection["recvonly"] = 1] = "recvonly";
    AudioDirection[AudioDirection["sendonly"] = 2] = "sendonly";
    AudioDirection[AudioDirection["sendrecv"] = 3] = "sendrecv";
})(AudioDirection || (AudioDirection = {}));
export const CAMERA_AUDIO = 'ip_camera';
export const SPEAKER_AUDIO = 'ip_speaker';
export const STREAM_TYPE_LIVE = "live";
export const STREAM_TYPE_PLAYBACK = "playback";
export const STREAM_TYPE_TWO_WAY_AUDIO = "two-way-audio";
export var ResDeviceType;
(function (ResDeviceType) {
    ResDeviceType["CAMERA"] = "camera";
    ResDeviceType["NVR"] = "nvr";
    ResDeviceType["SPEAKER"] = "speaker";
    ResDeviceType["PRESET"] = "preset";
    ResDeviceType["DOWNLOADER"] = "downloader";
    ResDeviceType["EVENT"] = "event";
})(ResDeviceType || (ResDeviceType = {}));
export var PresetWebrtcAction;
(function (PresetWebrtcAction) {
    PresetWebrtcAction["LIST"] = "ptz.preset.list";
    PresetWebrtcAction["SET"] = "ptz.preset.set";
    PresetWebrtcAction["DELETE"] = "ptz.preset.del";
    PresetWebrtcAction["GOTO"] = "ptz.preset.goto";
    PresetWebrtcAction["GET_IMG"] = "ptz.preset.get_img";
})(PresetWebrtcAction || (PresetWebrtcAction = {}));
export var EventWebrtcAction;
(function (EventWebrtcAction) {
    EventWebrtcAction["GetMedia"] = "event.get_media";
})(EventWebrtcAction || (EventWebrtcAction = {}));
export var SpeakerWebrtcAction;
(function (SpeakerWebrtcAction) {
    SpeakerWebrtcAction["SPEAK"] = "speaker.speak";
    SpeakerWebrtcAction["PLAY"] = "speaker.play";
    SpeakerWebrtcAction["CONFIG"] = "speaker.config";
})(SpeakerWebrtcAction || (SpeakerWebrtcAction = {}));
export var CameraSpeakerAction;
(function (CameraSpeakerAction) {
    CameraSpeakerAction["SPEAK"] = "camera.speak";
    CameraSpeakerAction["CONFIG"] = "camera.audio.config";
})(CameraSpeakerAction || (CameraSpeakerAction = {}));
export var MediaKind;
(function (MediaKind) {
    MediaKind["VIDEO"] = "video";
    MediaKind["AUDIO"] = "audio";
})(MediaKind || (MediaKind = {}));
